import TagModel from '../models/TagModel';
import BaseStore from './BaseStore';

class TagStore extends BaseStore {
  constructor(transportLayer) {
    super(TagModel, transportLayer);
  }
}

export default TagStore;



// WEBPACK FOOTER //
// ./src/stores/TagStore.js